import { Button } from 'semantic-ui-react';
import styled from 'styled-components';

import { breakpoint } from './theme';

const StyledButton = styled(Button)`
  &&& {
    margin: 0;
    border-radius: 5px;
    padding: 1.3rem 0.5rem;
    font-weight: 600;

    ${breakpoint.up.md`
      padding: 1.8rem 0.5rem;
    `}
  }
`;

export { StyledButton as Button };
